var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.68 17.2259C14.4958 17.2259 17.5891 14.1325 17.5891 10.3168C17.5891 6.50098 14.4958 3.40767 10.68 3.40767C6.86426 3.40767 3.77095 6.50098 3.77095 10.3168C3.77095 14.1325 6.86426 17.2259 10.68 17.2259ZM10.68 18.6804C15.2992 18.6804 19.0437 14.9359 19.0437 10.3168C19.0437 5.69765 15.2992 1.95312 10.68 1.95312C6.06093 1.95312 2.31641 5.69765 2.31641 10.3168C2.31641 14.9359 6.06093 18.6804 10.68 18.6804Z",
    fill: "#557FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5007 13.9533C10.3269 13.9699 10.1535 13.9178 10.0176 13.8082C9.88164 13.6986 9.79402 13.5402 9.77344 13.3668V9.44895C9.79402 9.27556 9.88164 9.11711 10.0176 9.00749C10.1535 8.89787 10.3269 8.8458 10.5007 8.86241C10.6745 8.8458 10.8479 8.89787 10.9839 9.00749C11.1198 9.11711 11.2074 9.27556 11.228 9.44895V13.3668C11.2074 13.5402 11.1198 13.6986 10.9839 13.8082C10.8479 13.9178 10.6745 13.9699 10.5007 13.9533Z",
    fill: "#557FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4989 6.31641C10.3191 6.31641 10.1434 6.36972 9.99387 6.46962C9.84437 6.56951 9.72785 6.71149 9.65904 6.8776C9.59024 7.04372 9.57223 7.22651 9.60731 7.40285C9.64239 7.5792 9.72897 7.74118 9.85611 7.86832C9.98325 7.99546 10.1452 8.08204 10.3216 8.11712C10.4979 8.1522 10.6807 8.13419 10.8468 8.06539C11.0129 7.99658 11.1549 7.88006 11.2548 7.73056C11.3547 7.58106 11.408 7.4053 11.408 7.2255C11.408 6.98439 11.3122 6.75316 11.1418 6.58267C10.9713 6.41219 10.74 6.31641 10.4989 6.31641",
    fill: "#557FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInfoTooltip);
export default __webpack_public_path__ + "static/media/icons-info-tooltip.4498a0d313fb6b77c7874dc5074c186c.svg";
export { ForwardRef as ReactComponent };